export enum A48ReportTypes {
    PARAEDUCATOR = 0,
    TEACHER = 1,
    EMERGENCY_CERTIFIED = 2
}
